import { useEffect } from 'react';

export const custState = {
    skip: false,
}

export function useSkip(callback){
    
    const skip = custState.skip;
        
    useEffect(() => {
        if(skip === 'true') callback();
    }, [])
}

